"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const react_1 = require("react");
const theme_1 = require("@zapier/theme");
const design_system_1 = require("@zapier/design-system");
const ruleGroupActionsContainer = core_1.css `
  padding: ${theme_1.Spacing.small}px 0px;
  display: flex;
`;
function RuleGroupActions(props) {
    const onAddRule = () => props.onAddRule(props.group);
    const onAddGroup = () => props.onAddGroup();
    return (core_1.jsx("div", { css: ruleGroupActionsContainer },
        core_1.jsx(design_system_1.Button, { color: "grey", iconBefore: "formAdd", onClick: onAddRule, size: "xsmall" }, "And"),
        props.canAddGroup && (core_1.jsx(react_1.Fragment, null,
            core_1.jsx(design_system_1.Spacer, { width: theme_1.Spacing.small }),
            core_1.jsx(design_system_1.Button, { color: "grey", iconBefore: "formAdd", onClick: onAddGroup, size: "xsmall" }, "Or")))));
}
exports.default = RuleGroupActions;
